module.exports = __webpack_public_path__ + "img/bridge.2f553edd.svg";